// @flow

import { cmsAxios } from './axios-config';

const getPrivacyPolicy = () => {
  return cmsAxios.get('/privacy-policy');
};

export default getPrivacyPolicy;
